export default {"src":"/_next/static/media/mosque.b4a8f518.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};